import React from 'react';
import { Seo } from './components/Seo';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { DealerBand } from './components/DealerBand';
import { Repower } from './components/Repower';
import { Engines } from './components/Engines';
import { PreOwned } from './components/PreOwned';
import { Breather } from './components/Breather';
import { Service } from './components/Service';
import { TestTank } from './components/TestTank';
import { Fleets } from './components/Fleets';
import { Storage } from './components/Storage';
import { Brands } from './components/Brands';
import { MeetMichael } from './components/MeetMichael';
import { ServiceArea } from './components/ServiceArea';
import { Gallery } from './components/Gallery';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { MobileCallBar } from './components/MobileCallBar';
import { ChatWidget } from './components/ChatWidget';
import { images } from './data/site';
interface AppProps {
  heroBackground?: 'video' | 'slideshow';
}
export function App({
  heroBackground = 'video'
}: AppProps) {
  return <div className="w-full bg-white font-sans text-ink antialiased" data-id="element-0" data-mp="3mj6hxs835sdv">
      <Seo data-id="element-1" data-mp="3rcsw5otwe4bs" />
      <Header data-id="element-2" data-mp="3rd189ei755lx" />
      <main data-id="element-3" data-mp="3relv0hy9rk98">
        <Hero background={heroBackground} data-id="element-4" data-mp="5osn3wyp084" />
        <DealerBand data-id="element-5" data-mp="4n6a3ahwrb3" />
        <Repower data-id="element-6" data-mp="56qjqnmbrsa" />
        <Engines data-id="element-7" data-mp="7sxbo2oq39g" />
        <PreOwned data-id="element-8" data-mp="2zld4hgdhhrep" />
        <Breather src={images.breatherWake} alt="Aerial view of a boat wake trailing across glassy water on the Albemarle Sound" data-id="element-9" data-mp="2zlv32jnmchps" />
        <Service data-id="element-10" data-mp="33mymfg4vkvvr" />
        <TestTank data-id="element-11" data-mp="33oi3h8ycvayl" />
        <Fleets data-id="element-12" data-mp="38m1gy6n8bjph" />
        <Storage data-id="element-13" data-mp="38li95irambp6" />
        <Brands data-id="element-14" data-mp="38l03xwmnkn54" />
        <Breather src={images.breatherHarbor} alt="Sunrise over a quiet harbor with fishing boats tied at the dock" data-id="element-15" data-mp="38kgl8dp6huq1" />
        <MeetMichael data-id="element-16" data-mp="3dirxsw6uyjby" />
        <ServiceArea data-id="element-17" data-mp="nvsup6ui4rx0" />
        <Gallery data-id="element-18" data-mp="nwc1brepbtvq" />
        <Contact data-id="element-19" data-mp="nur7y544igzg" />
      </main>
      <Footer data-id="element-20" data-mp="nxn9e3f6jnsn" />
      <MobileCallBar data-id="element-21" data-mp="sunbk38ws6eh" />
      <ChatWidget data-id="element-22" data-mp="stue5svuat90" />
    </div>;
}